<div class="main-content">
    <!--Panel Loader-->
    <kuba-busy [busy]="showLoader" message="PROCESSING"></kuba-busy>
    <!--Panel Loader-->
    <div class="main-heading">
        <span *ngIf="featureKey">
            <a *ngIf="featureKey!=null" class="btn btn-icon" href="javascript:void(0);" (click)="goBack()">
                <span class="icon ic-xs icon-back"></span>
            </a>
            <span>{{VehiclesCompleteChecklist.Title}}</span>
        </span>
    </div>
    <div class="card">
        <div class="card-body">
            <div class="specialized-checklist">
              <header><strong>{{'CHECKLIST_REDESIGN.ANSWERED' | translate:{answered: answered, total: checkpoints.length} }}</strong>
                <progress [value]="answered" [max]="checkpoints.length || 1"></progress>
              </header>
              <nav *ngIf="checkpoints.length >= 25" class="specialized-checklist-nav">
                <button class="btn btn-outline-secondary" *ngFor="let page of checkpointPages" (click)="checkpointPage = page" [class.active]="checkpointPage === page">{{page * 10 + 1}}–{{MathMin((page + 1) * 10, checkpoints.length)}}</button>
                <button class="btn btn-outline-secondary" (click)="markRestNa()">{{'CHECKLIST_REDESIGN.MARK_REST_NA' | translate}}</button>
              </nav>
              <nav class="specialized-checklist-nav" *ngIf="checkpoints.length >= 25">
                <button type="button" class="btn btn-outline-secondary" [class.active]="checkpointFilter === 'all'" (click)="checkpointFilter = 'all'">{{'CHECKLIST_REDESIGN.ALL' | translate}}</button>
                <button type="button" class="btn btn-outline-secondary" [class.active]="checkpointFilter === 'unanswered'" (click)="checkpointFilter = 'unanswered'">{{'CHECKLIST_REDESIGN.UNANSWERED' | translate}}</button>
                <button type="button" class="btn btn-outline-secondary" [class.active]="checkpointFilter === 'deviations'" (click)="checkpointFilter = 'deviations'">{{'DEVIATIONS' | translate}}</button>
              </nav>
              <button type="button" class="btn btn-link" *ngIf="answered < checkpoints.length" (click)="firstUnanswered()">{{'CHECKLIST_REDESIGN.FIRST_UNANSWERED' | translate}}</button>
              <article *ngFor="let List of visibleCheckpoints; let i = index" class="specialized-checkpoint">
                <h3>{{List.CheckpointName}}</h3>

                <div class="specialized-checkpoint-status">
                  <button type="button" *ngFor="let status of List.Status; let statusIndex = index" class="btn btn-outline-primary" [class.active]="status.Value" [attr.aria-pressed]="status.Value" (click)="setStatus(status, List.Status)">{{['OK', 'NOT_APPLICABLE', 'DEVIATION'][statusIndex] | translate}}</button>
                </div>
                <label>{{'COMMENTS' | translate}}<textarea [(ngModel)]="List.Comments" (ngModelChange)="queueDraft()" class="form-control" rows="2"></textarea></label>
              </article>
              <p role="status">{{draftStatus | translate}}</p>
            </div>
            <div class="action-btns-wrapper">
                <button *ngIf="featureKey!=null" class="btn btn-outline-secondary" (click)="goBack()">
                    <i class="pi pi-arrow-left"></i>
                    <span translate>BACK_LIST</span>
                </button>
                <button [disabled]="checkValid() || draftSaving || showLoader" class="btn btn-primary" (click)="SaveCompleteCheckList()">
                    <span translate>SAVE</span></button>
            </div>
        </div>
    </div>
</div>
